import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { FooterContainer, Button, LearnTipBody } from './styled-components';
import { Body } from './utils';
import { LearnTipContent } from './LearnTipContent';

var LearnTip = function LearnTip(_ref) {
  var index = _ref.index,
      size = _ref.size,
      isLastStep = _ref.isLastStep,
      step = _ref.step,
      skipProps = _ref.skipProps,
      primaryProps = _ref.primaryProps,
      tooltipProps = _ref.tooltipProps,
      activeStep = _ref.activeStep,
      className = _ref.className;

  var getButtonMessage = function getButtonMessage() {
    if (step.buttonMessage) {
      return step.buttonMessage;
    }

    if (size === 1) {
      return 'Got it';
    }

    return isLastStep ? 'Close' : 'Next';
  };

  return /*#__PURE__*/React.createElement(Body, {
    "data-testid": step.dataTestId,
    key: index,
    initialPose: "exit",
    pose: index === activeStep ? 'enter' : 'exit'
  }, /*#__PURE__*/React.createElement(LearnTipBody, _extends({}, tooltipProps, {
    width: step.width,
    tipAdjustment: step.tipAdjustment,
    direction: step.placement,
    pointerAdjustment: step.pointerAdjustment,
    className: className
  }), /*#__PURE__*/React.createElement(LearnTipContent, {
    step: step,
    skipProps: skipProps
  }), step.showButtons && /*#__PURE__*/React.createElement(FooterContainer, null, size > 1 && "".concat(index + 1, " / ").concat(size), /*#__PURE__*/React.createElement(Button, primaryProps, getButtonMessage()))));
};

export default LearnTip;